.productSoldMoreInfoContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: end;
    z-index: 1;
}

.productSoldMoreInfoButton {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1
}

.productSoldMoreInfoButton svg {
    fill: var(--static-text-strong)
}

.productsSoldDetailModalContainer {
    position: absolute;
    z-index: 1000;
    box-shadow: var(--box-shadow);
    width: 300px;
    background: var(--static-background-standard);
    padding: 0;
    border-radius: 0.75rem;
    border: 1px solid var(--primary-enabled);
    outline: 0.5px solid var(--primary-enabled);
}

.listingItem {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 1rem;
    border-bottom: 1px solid var(--static-divider-standard);
    padding: 1rem 3.5rem 0.75rem 1.25rem;
}

.listingImage {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 0.5rem;
    object-fit: cover;
    object-position: center;
}

.listingItemDetail {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    overflow: hidden;
}

.listingItemDetail p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.listingSku {
    color: var(--static-text-weak);
    font-size: var(--small-text);
    font-weight: normal;
}

.closeButton {
    position: absolute;
    top: 0.75rem;
    right: 1.5rem;
    cursor: pointer;
    background-color: transparent;
    border: none;
    padding: 0.5rem;
    z-index: 2;
    color: var(--static-text-standard);
}

.closeButton:hover {
    color: var(--primary-enabled);
}

.statCard {
    padding: 0.75rem 1.25rem;
    background: var(--static-background-standard);
    border-bottom: 1px solid var(--static-divider-standard);
}

.footer {
    padding: 0.75rem 1.5rem;
    position: relative;
    background: var(--static-background-weak);
    border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
}